/* =====================================================================
   Annette D. — accordéon de la FAQ (sections/annetted-faq.liquid)
   ---------------------------------------------------------------------
   Sans ce script, la FAQ marche déjà : chaque question est un
   <details name="annetted-faq">, le navigateur n'en laisse qu'une
   ouverte et tout se joue au clavier. Ce script ajoute seulement
   l'ouverture animée — hauteur et opacité en 300 ms, le pli du prompt
   « rocket-faq » — et l'ouverture de la question visée par l'adresse
   (/pages/faq#annetted-faq-3).

   Pour animer la fermeture de la réponse précédente, il reprend à son
   compte l'exclusivité : il retire l'attribut `name` (qui fermerait
   l'autre réponse d'un coup) et ferme lui-même les autres questions.
   Avec « réduire les animations », il ne touche à rien.
   ===================================================================== */

(() => {
  const mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DUREE = 300;
  const COURBE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const FERMETURE = 'data-annetted-fermeture';

  /** Ouvre ou ferme une question en animant sa réponse. */
  const animer = (details, ouvrir) => {
    const reponse = details.querySelector('.annetted-faq__reponse');
    if (!reponse || typeof reponse.animate !== 'function') {
      details.open = ouvrir;
      return;
    }

    // Une animation en cours repart de la hauteur où elle en est.
    const depart = reponse.getBoundingClientRect().height;
    details.annettedAnimation?.cancel();

    let arrivee;
    if (ouvrir) {
      details.removeAttribute(FERMETURE);
      details.open = true;
      arrivee = reponse.scrollHeight;
    } else {
      details.setAttribute(FERMETURE, '');
      arrivee = 0;
    }

    reponse.style.overflow = 'hidden';
    const animation = reponse.animate(
      [
        { height: `${depart}px`, opacity: ouvrir ? Math.min(1, depart / (arrivee || 1)) : 1 },
        { height: `${arrivee}px`, opacity: ouvrir ? 1 : 0 },
      ],
      { duration: DUREE, easing: COURBE }
    );
    details.annettedAnimation = animation;

    animation.addEventListener('finish', () => {
      details.annettedAnimation = null;
      reponse.style.removeProperty('overflow');
      if (!ouvrir) {
        details.open = false;
        details.removeAttribute(FERMETURE);
      }
    });
    animation.addEventListener('cancel', () => {
      reponse.style.removeProperty('overflow');
    });
  };

  const estOuverte = (details) => details.open && !details.hasAttribute(FERMETURE);

  /** Ouvre la question visée par l'adresse, sans animation. */
  const ouvrirDepuisAdresse = (questions) => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    const cible = questions.find((details) => details.id === id);
    if (!cible) return;
    questions.forEach((details) => {
      details.annettedAnimation?.cancel();
      details.removeAttribute(FERMETURE);
      details.open = details === cible;
    });
    cible.querySelector('summary')?.focus({ preventScroll: true });
  };

  const brancher = (racine = document) => {
    racine.querySelectorAll('[data-annetted-faq]').forEach((liste) => {
      if (liste.annettedPret) return;
      liste.annettedPret = true;

      const questions = Array.from(liste.querySelectorAll(':scope > details'));
      if (!questions.length) return;

      ouvrirDepuisAdresse(questions);
      window.addEventListener('hashchange', () => ouvrirDepuisAdresse(questions));

      if (mouvementReduit.matches) return;

      questions.forEach((details) => {
        details.removeAttribute('name');
        const question = details.querySelector('summary');
        if (!question) return;

        question.addEventListener('click', (event) => {
          event.preventDefault();
          if (estOuverte(details)) {
            animer(details, false);
            return;
          }
          questions.forEach((autre) => {
            if (autre !== details && estOuverte(autre)) animer(autre, false);
          });
          animer(details, true);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => brancher(), { once: true });
  } else {
    brancher();
  }

  document.addEventListener('shopify:section:load', (event) => brancher(event.target));
})();
